import keycloakStore from "@/businesslogic/stores/keycloakStore";
import axios from "axios";

class MaklerDatenService {
  http() {
    const keycloakAccessToken = keycloakStore().getKeycloakAccessToken();

    let headers;
    if (keycloakAccessToken) {
      headers = {
        Authorization: "Bearer " + keycloakAccessToken,
        "Content-Type": "application/json",
      };
    }

    return axios.create({
      baseURL: process.env.VUE_APP_MAKLERPORTAL_BACKEND_URL,
      headers: headers,
    });
  }

  ladeVermittlerdaten(produkt: string, vermittlerNummer: string) {
    if (vermittlerNummer && vermittlerNummer !== "") {
      return this.http().get("/api/vermittlerdaten/" + vermittlerNummer + "/" + produkt);
    }

    return this.http().get(
      "/api/vermittlerdaten/" + this.vermittlerNummer(keycloakStore().getVermittlerNummern()) + "/" + produkt,
    );
  }

  ladeVermittlerdatenMaklerLink(produkt: string, vermittlerNummer: string) {
    return this.http().get("/api/makler-tarifrechner/vermittlerdaten/" + vermittlerNummer + "/" + produkt);
  }

  ladeAbsenderdaten(vermittlerNummer: string) {
    if (vermittlerNummer && vermittlerNummer !== "") {
      return this.http().get("/api/vermittlerdaten/absenderinformationen/" + vermittlerNummer);
    }

    return this.http().get(
      "/api/vermittlerdaten/absenderinformationen/" + this.vermittlerNummer(keycloakStore().getVermittlerNummern()),
    );
  }

  ladeVorbelegung(vorbelegungsId: string) {
    return this.http().get("/api/vorbelegung/" + vorbelegungsId);
  }

  vermittlerNummer(vermittlerNummern: string): string {
    if (vermittlerNummern.includes(";")) {
      return vermittlerNummern.split(";")[0];
    }
    return vermittlerNummern;
  }

  vermittlerNummernDesMaklers() {
    return this.http().get("/api/vermittlerdaten/vermittlernummern");
  }
}

export default new MaklerDatenService();
